module.exports = __webpack_public_path__ + "static/media/teenpatti.ba2b911b.jpeg";